import checkPermission from "@/middleware/checkPermission.js";

function importFromAccountDir(pageName) {
    return () =>
        import(`../pages/Account/${pageName}.vue`).then(
            (m) => m.default || m,
        );
}
function importFromComponentDir(dir, pageName) {
    return () =>
        import(`../pages/Account/${dir}/${pageName}.vue`).then(
            (m) => m.default || m,
        );
}
export default [
    {
        path: "/account",
        component: importFromAccountDir("Index"),
        meta: {
            title: "Account",
        },
        children: [
            {
                path: "/account/personal-info",
                name: "personal-info",
                component: importFromComponentDir("Components", "PersonalInfo"),
                meta: {
                    title: "Personal Info",
                },
            },
            {
                path: "/account/company-info",
                name: "company-info",
                component: importFromComponentDir("Components", "CompanyInfo"),
                meta: {
                    title: "Company Info",
                    middleware: [checkPermission],
                    permissions: ["admin_access"],
                },
            },
            {
                path: "/account/change-password",
                name: "change-password",
                component: importFromComponentDir("Components", "ChangePassword"),
                meta: {
                    title: "Change Password",
                },
            },
            {
                path: "/account/team-members",
                name: "team-management",
                component: importFromComponentDir("Components", "TeamMember"),
                meta: {
                    title: "Team Management",
                    middleware: [checkPermission],
                    permissions: ["admin_access"],
                },
            }, {
                path: "/account/team-members/create",
                name: "team-management-create",
                component: importFromComponentDir("Components", "TeamMemberCreate"),
                meta: {
                    title: "Team Management",
                    middleware: [checkPermission],
                    permissions: ["admin_access"],
                },
            }, {
                path: "/account/team-members/edit/:id",
                name: "team-management-edit",
                component: importFromComponentDir("Components", "TeamMemberCreate"),
                meta: {
                    title: "Team Management",
                    middleware: [checkPermission],
                    permissions: ["admin_access"],
                },
            },
            {
                path: "/account/plans",
                name: "plans",
                component: importFromComponentDir("Components", "Plans"),
                meta: {
                    title: "Plans",
                    middleware: [checkPermission],
                    permissions: ["admin_access"],
                },
            },
            {
                path: "/account/payment-history",
                name: "payment-history",
                component: importFromComponentDir("Components", "PaymentHistory"),
                meta: {
                    title: "Payment History",
                    middleware: [checkPermission],
                    permissions: ["admin_access"],
                },
            },
            {
                path: "/account/usage",
                name: "accountUsage",
                component: importFromComponentDir("Components", "Usage"),
                meta: {
                    title: "Usage",
                    middleware: [checkPermission],
                    permissions: ["admin_access"],
                },
            },
            {
                path: "/account/cache-settings",
                name: "cache-settings",
                component: importFromComponentDir("Components", "Cache"),
                meta: {
                    title: "Cache",
                    middleware: [checkPermission],
                    permissions: ["admin_access"],
                },
            },
        ],
    },
];
